import api from './api';

const bonusService = {
    // Get all available bonuses for the user with their current progress
    getUserBonuses: async () => {
        try {
            const response = await api.get('/bonuses');
            return response;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Claim a completed bonus reward
    claimBonus: async (userBonusId) => {
        try {
            const response = await api.post(`/bonuses/claim/${userBonusId}`);
            return response;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Admin: Get all bonuses
    getAllBonuses: async () => {
        try {
            const response = await api.get('/admin/bonuses');
            return response;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Admin: Create a new bonus
    createBonus: async (bonusData) => {
        try {
            const response = await api.post('/admin/bonuses', bonusData);
            return response;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Admin: Update a bonus
    updateBonus: async (id, bonusData) => {
        try {
            const response = await api.put(`/admin/bonuses/${id}`, bonusData);
            return response;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Admin: Delete a bonus
    deleteBonus: async (id) => {
        try {
            const response = await api.delete(`/admin/bonuses/${id}`);
            return response;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};

export default bonusService;
